import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Alert } from "reactstrap";

import { createFormField } from '../../../models/FormField';
import { createForm } from '../../../models/Form';
import { modelOf } from '../../../prop-types';
import CampaignCodeForm from "../CampaignCodeForm";
import CampaignCodeStore from "../../../store/CampaignCodeStore";
import FormFieldId from "../../../types/FormFieldId";
import { minLength } from "../../../util/formValidators";
import { labels } from "../../../util/formLabels";
import RequestState from "../../../types/RequestState";
import UnexpectedError from "../../loader/UnexpectedError";

const campaignCodeForm = createForm({});

const CampaignCode = ({
  campaignCodeStore,
}) => {
  const [message, setMessage] = useState(null);

  const initializeForm = () => {
    const campaignCodeFormFields = {
      [FormFieldId.CAMPAIGN_CODE]: createFormField({}, [minLength(labels.campaignCode, 2)]),
    };
    campaignCodeForm.setFields(campaignCodeFormFields);
  };

  if (!campaignCodeForm.getField(FormFieldId.CAMPAIGN_CODE)) {
    initializeForm();
  }

  const setCampaignCode = (campaignCode) => {
    setMessage(
      <Alert color="info">
        <FormattedMessage
          id="campaign.activationInProgress"
          defaultMessage="Activating code..."
        />
      </Alert>
    );

    campaignCodeStore
      .setCode(campaignCode)
      .then(() => {
        setMessage(
          <Alert color="success">
            <FormattedMessage
              id="campaign.setSuccess"
              defaultMessage="The campaign code was activated successfully!"
            />
          </Alert>
        );

        window.location.reload();
      })
      .catch((e) => {
        const status = e.response ? e.response.status : 500;

        if (status === 404) {
          setMessage(
            <Alert color="danger">
              <FormattedMessage
                id="campaign.setError"
                defaultMessage="The entered campaign code was not found."
              />
            </Alert>
          );
        } else {
          setMessage(<UnexpectedError />);
        }
      });
  }

  const handleSet = (e) => {
    e.preventDefault();

    const campaignCodeField = campaignCodeForm.getField(FormFieldId.CAMPAIGN_CODE);
    setCampaignCode(campaignCodeField.value);
  };

  const disabled =
    campaignCodeStore.state === RequestState.LOADING
    || campaignCodeStore.setCodeState === RequestState.LOADING;

  if(!campaignCodeForm) {
    return null;
  }

  return (
    <div className="CampaignCode">
      {campaignCodeForm && (
        <CampaignCodeForm
          campaignCodeForm={campaignCodeForm}
          disabled={disabled}
          onCodeUpdate={handleSet}
        />
      )}
      {message}
    </div>
  );
}


CampaignCode.propTypes = {
  campaignCodeStore: modelOf(CampaignCodeStore).isRequired,
};

export default inject(
  'campaignCodeStore'
)(injectIntl(observer(CampaignCode)));
